import ProdutoService from "@/services/ProdutoService";
import ProdutoReservaService from "@/services/ProdutoReservaService";
import { router } from "@/router";
import Helper from "@/helper";
const helper = Helper;
import store from "@/store";

export const actions = {
  cadastrarProduto: ({ commit, dispatch }) => {
    commit("setProduto", {
      tipo: "PRODUTO",
      descricao: "",
      marca: "",
      codigo_barra: "",
      unidade: "UN",
      referencia: "",
      preco_custo: "0,00",
      margem_lucro: "0,00",
      preco_venda: "0,00",
      cfop: "5.102",
      cfop_fora_estado: "6.102",
      cest: "",
      ncm: "",
      fornecedor_id: "",
      secao_id: "",
      grupo_id: "",
      cst_csosn: "102",
      cst_pis: "08",
      cst_confins: "08",
      cst_ipi: "99",
      habilitado: true,
      descricao_servico: "",
      estoque_minimo: "",
      tanque: false,
      capacidade_litro: "0,00",
      altura: "0,00",
      largura: "0,00",
      profundidade: "0,00",
      desconto_maximo: "0,00",
      comissao: "0,00",
      comissao_real: "0,00",
    });
    commit("setFotoProduto", null);
    dispatch("setModalCadastroProduto", true);
  },
  listarProdutos: ({ commit }, data) => {
    commit("setOverlay", true);
    ProdutoService.listar(data)
      .then((res) => {
        commit("setProdutos", res.data);
        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  listarServicos: ({ commit }, data) => {
    commit("setOverlay", true);
    ProdutoService.listarServicos(data)
      .then((res) => {
        commit("setProdutos", res.data);
        commit("setOverlay", false);
      })
      .catch((e) => {
        commit("setOverlay", false);
      });
  },
  setProduto: ({ commit }, data) => {
    let produto = data;
    if (!data.id) {
      commit("snackbarError", "Produto excluído.");
    }
    produto.preco_venda = helper.formatReal(parseFloat(data.preco_venda));
    produto.preco_custo = helper.formatReal(parseFloat(data.preco_custo));
    produto.margem_lucro = helper.formatReal(parseFloat(data.margem_lucro));
    produto.comissao = helper.formatReal(parseFloat(data.comissao));
    produto.comissao_real = helper.formatReal(parseFloat(data.comissao_real));
    commit("setProduto", produto);
  },
  visualizarProduto: ({ commit, dispatch }, id) => {
    commit("setOverlay", true);
    ProdutoService.editar(id)
      .then((res) => {
        dispatch("setProduto", res.data);
        commit("setFotoProduto", res.data.url_foto);
        commit("setOverlay", false);
        dispatch("setModalCadastroProduto", true);
        // dispatch("setModalListarProduto", false)
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  buscarProduto: ({ commit, dispatch }, id) => {
    commit("setOverlay", true);
    ProdutoService.editar(id)
      .then((res) => {
        commit("setProduto", res.data);
        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  async salvarProduto({ commit, dispatch }, data) {
    commit("setOverlay", true);
    await ProdutoService.salvar(data)
      .then((res) => {
        dispatch("setProduto", res.data);
        dispatch("listarProdutos", { limite: 20, pagina: 1 });
        // router.push({name:'produtoEditar', params: {id: res.data.id}})
        commit("setOverlay", false);
        commit("snackbarSuccess", "Produto cadastrado.");

        return res;
      })
      .catch((e) => {
        commit("setOverlay", false);
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("snackbarError", "Erro ao cadastrar produto.");
      });
  },
  atualizarProduto: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    ProdutoService.atualizar(data)
      .then((res) => {
        dispatch("listarProdutos", { limite: 20, pagina: 1 });
        commit("setOverlay", false);
        commit("snackbarInfo", "Produto atualizado.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar produto.");
      });
  },
  excluirProduto: ({ commit, dispatch }, id) => {
    dispatch("setModalCadastroProduto", false);
    dispatch("setModalExcluirProduto", false);
    commit("setOverlay", true);
    ProdutoService.excluir(id)
      .then((res) => {
        dispatch("listarProdutos", { limite: 20, pagina: 1 });
        // router.push({name: 'produtos'})
        commit("setOverlay", false);
        commit("snackbarError", "Produto excluído.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir produto.");
      });
  },
  setModalCadastroProduto: ({ commit, dispatch }, status) => {
    commit("setModalCadastroProduto", false);
    setTimeout(() => {
      commit("setModalCadastroProduto", status);
    }, 100);
  },
  setModalClonarProduto: ({ commit }, status) => {
    commit("setModalClonarProduto", false);
    setTimeout(() => {
      commit("setModalClonarProduto", status);
    }, 100);
  },
  setModalExcluirProduto: ({ commit }, status) => {
    commit("setModalExcluirProduto", false);
    setTimeout(() => {
      commit("setModalExcluirProduto", status);
    }, 100);
  },
  setModalTransferenciaEstoqueProduto: ({ commit }, status) => {
    commit("setModalTransferenciaEstoqueProduto", false);
    setTimeout(() => {
      commit("setModalTransferenciaEstoqueProduto", status);
    }, 100);
  },
  pesquisarProduto: ({ commit }, data) => {
    commit("setOverlay", true);
    ProdutoService.pesquisar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setProdutos", res.data);
      })
      .catch((e) => {
        commit("snackbarError", "Produto não encontrado");
        commit("setOverlay", false);
      });
  },
  pesquisarProdutoPorCodigoDeBarras: ({ commit }, codigo_barras) => {
    ProdutoService.porCodigoDeBarras(codigo_barras)
      .then((res) => {
        if (res.data.id) {
          commit("setProduto", res.data);
          commit("setItemOrcamento", res.data);
        } else {
          commit("snackbarError", "Produto não encontado.");
        }
      })
      .catch((e) => console.log(e));
  },
  produtoVisualizarPagina: ({ commit }, data) => {
    commit("setOverlay", true);

    ProdutoService.visualizarPagina(data)
      .then((res) => {
        if (res.data.data.length > 0) {
          commit("setProdutos", res.data);
        } else {
          commit("snackbarError", "Produto não encontrado.");
        }
        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  habilitarDesabilitarProduto: ({ commit }, data) => {
    let habilitar = "";
    if (data.habilitado == false) {
      habilitar = false;
      commit("snackbarError", "Produto desabilitado.");
    } else {
      commit("snackbarSuccess", "Produto habilitado.");
      habilitar = true;
    }

    const produto = { id: data.id, ...data, habilitado: habilitar };

    ProdutoService.atualizar(produto)
      .then()
      .catch((e) => {
        commit("snackbarError", "Erro ao habilitar/desabilitar produto.");
      });
  },

  baixarReservaProduto: ({ commit }, produtoId) => {
    commit("setOverlay", true);
    ProdutoReservaService.baixarReserva(produtoId)
      .then((res) => {
        store.getters.getProduto.reserva[0].quantidade =
          store.getters.getProduto.reserva[0].quantidade - 1;
        commit("setOverlay", false);
        commit("snackbarSuccess", "Baixa efetuada.");
      })
      .catch((e) => {
        console.log(e);
        commit("snackbarError", "Erro ao efetuar baixa.");
        commit("setOverlay", false);
      });
  },
  clonarProduto: ({ commit, dispatch }, produtoId) => {
    commit("setOverlay", true);
    ProdutoService.clonar(produtoId)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarSuccess", "Produto clonado com sucesso.");
        dispatch("setProduto", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao clonar produto.");
        console.log(e);
      });
  },
};

export default {};
